import { Component, computed, input, model, output } from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { MatIconModule } from '@angular/material/icon';
import { ProjectAvatarComponent } from '@app/shared/components/project-avatar/project-avatar.component';
import { environment } from '@env/environment';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Project avatar picker. Value is the avatar file id (Signal Forms `[formField]` or `[(value)]`); picking an image
 * emits `inputChanged` with the file – the parent uploads it and writes the resulting id back into the value.
 */
@Component({
  selector: 'proffeo-project-avatar-image',
  templateUrl: './project-avatar-image.component.html',
  imports: [TranslatePipe, MatIconModule, ProjectAvatarComponent],
  host: {
    '(focusout)': 'touch.emit()'
  }
})
export class ProjectAvatarImageComponent implements FormValueControl<string> {
  protected readonly avatarUrl = computed((): string | undefined =>
    this.value() ? `${environment.ServerUrl}avatars/Projects/${this.value()}.jpg` : undefined
  );
  protected readonly noImage = computed(() => !this.avatarUrl());

  /** Avatar file id. */
  public readonly value = model<string>('');
  public readonly projectName = input<string>();
  public readonly inputChanged = output<File>();
  /** Emits when focus leaves the control – marks a `[formField]` as touched. */
  public readonly touch = output<void>();

  protected onFileSelected(fileInput: HTMLInputElement): void {
    const image = fileInput.files?.[0];
    if (image) {
      this.inputChanged.emit(image);
    }
  }
}
